import { default as deserialize } from 'app/utils/deserialize'
import { fetch, update } from 'app/utils/data'
import FormErrors from 'app/utils/form_errors'

const INITIAL_ITEM = null

export default {
  namespaced: true,

  state: {
    item: INITIAL_ITEM
  },

  getters: {
    meteredBilling: (state) => state.item,

    // The customer's metered billing configuration, from whichever source the
    // signed-in role is allowed to read.
    //
    // Only owner, admin, and billing roles may read /api/metered-billing, so for
    // editors `item` is always null. The same record rides along on the subscription
    // payload, which editors can read, so fall back to that. Without the fallback an
    // editor's `meteredBandwidthOn` reads `undefined` and the "metered billing is
    // off" predicates fire for customers who have it on -- telling them their
    // service was deactivated while it's still serving.
    //
    // `item` wins when populated: it's re-fetched when settings are saved, while the
    // subscription's copy is only as fresh as the last subscription fetch.
    meteredBillingSettings: (state, _getters, _rootState, rootGetters) => {
      return state.item || rootGetters['subscriptions/currentSubscription']?.meteredBilling || null
    }
  },

  mutations: {
    meteredBillingFetched(state, { meteredBilling }) {
      state.item = meteredBilling
    },

    resetState: (state) => {
      state.item = INITIAL_ITEM
    }
  },

  actions: {
    async fetchMeteredBilling({ commit }) {
      try {
        const response = await fetch({
          url: `/api/metered-billing`
        })
        const meteredBilling = await deserialize(response.data)

        commit('meteredBillingFetched', { meteredBilling })
      } catch (error) {
        throw new FormErrors(error.response.data.errors)
      }
    },

    async updateMeteredBilling({ commit, state }, changes) {
      try {
        const response = await update({
          url: `/api/metered-billing`,
          type: 'metered-billing',
          record: state.item,
          patch: true,
          changes
        })

        const meteredBilling = await deserialize(response.data)

        commit('meteredBillingFetched', { meteredBilling })

        return meteredBilling
      } catch (error) {
        throw new FormErrors(error.response.data.errors)
      }
    }
  }
}
